import { useMemo } from "react";
import { ApiClient } from "../services";

export const useClient = (args = {}) => {
  return useMemo(() => ApiClient(args), []);
};
